export default __webpack_public_path__ + "static/media/Raider's Tunic of the Bloody Fang.6c3c999a.jpg";